<!-- eslint-disable vue/valid-v-slot -->
<template>
  <section class="Records">
    <h1>South Dakota Mountain Lion Records</h1>
      <v-data-table
        :headers="headers"
        :items="records"
        item-value="id"
        class="elevation-1 text-center"
        items-per-page="50"
        dense
      >
        <template v-slot:item.row="{ index }">
          {{ index + 1 }}
        </template>
        <!-- Slot for rendering the images -->
        <template v-slot:item.images="{ item }">
          <div class="image-preview">
            <v-img
              v-for="(url, index) in item.images"
              :key="index"
              :src="url"
              max-width="50"
              max-height="50"
              class="mr-2"
            ></v-img>
          </div>
        </template>

        <!-- Slot for rendering the story link -->
        <template v-slot:item.story="{ item }">
          <v-btn v-if="item.story" :href="item.story" target="_blank" text flat>
            View Story
          </v-btn>
        </template>
        <template v-slot:top>
          <!-- <v-toolbar flat>
              <v-toolbar-title>Mountain Lion Records</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                clearable
              ></v-text-field>
            </v-toolbar> -->
        </template>
      </v-data-table>
    <v-container>
      <div>Want to see your mountain lion listed?</div>
      <v-btn color="primary">Email Us</v-btn>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "RecordsPage",
  data() {
    return {
      search: "",
      headers: [
        { title: "", value: "row", align: "start" }, // New header for row numbers
        { title: "Hunter", value: "hunter", align: "center" },
        { title: "Year", value: "year", align: "center" },
        { title: "County", value: "county", align: "center" },
        { title: "Method", value: "method", align: "center" },
        { title: "Images", value: "images", align: "center" }, // New header for images
        { title: "Story", value: "story", align: "center" }, // New header for story
        { title: "Score", value: "score", align: "end" },
      ],
      records: [
      {
          hunter: "Eric J. Weeman",
          year: "2021",
          county: "",
          weight: null,
          score: "14 15/16",
          method: "",
          story: null,
          images: [],
        },
        {
          hunter: "Frank L. Schmidt",
          year: "2011",
          county: "Custer",
          weight: null,
          score: "14 14/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "Brenden E. Hendrickson",
          year: "2009",
          county: "Custer",
          weight: null,
          score: "14 13/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "Jerry C. Schroeder	",
          year: "2014",
          county: "Custer",
          weight: null,
          score: "14 13/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "Eric Botkin",
          year: "2017",
          county: "Custer",
          weight: null,
          score: "14 12/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "Clinton M. DeBoer",
          year: "2017",
          county: "",
          weight: null,
          score: "14 9/16",
          method: "",
          story: null,
          images: [],
        },
        {
          hunter: "Jamie L. Soukup",
          year: "2023",
          county: "",
          weight: null,
          score: "14 8/16",
          method: "",
          story: null,
          images: [],
        },
        {
          hunter: "Aaron Punt",
          year: "2017",
          county: "Custer",
          weight: null,
          score: "14 6/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "David Goodwin",
          year: "2012",
          county: "Custer",
          weight: null,
          score: "14 3/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "Mark Weber",
          year: "2014",
          county: "Custer",
          weight: null,
          score: "13 15/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "Tim C Goodwin",
          year: "2009",
          county: "Custer",
          weight: null,
          score: "13 10/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "Tim R Goodwin",
          year: "2016",
          county: "Custer",
          weight: null,
          score: "13 10/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "David Goodwin",
          year: "2016",
          county: "Custer",
          weight: null,
          score: "13 5/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "Melissa Clemetson",
          year: "2015",
          county: "Custer",
          weight: null,
          score: "12 13/16",
          method: "Firearm",
          story: null,
          images: [],
        },
        {
          hunter: "Steve Moses",
          year: "2015",
          county: "Custer",
          weight: null,
          score: "12 9/16",
          method: "Firearm",
          story: null,
          images: [],
        },
      ],
    };
  },
};
</script>

<style scoped>
.Records {
  padding: 16px;
}
</style>
